export default "__VITE_ASSET__BmOFpxVw__"